/* const subjectsById = Object.fromEntries(
  Object.keys(allSubjects)
    .flatMap(s => allSubjects[s])
    .map(s => {
      const id = s.units.some(u => u.chapters.some(c => c.value))
        ? s.units[0].chapters[0].value
        : s.label.replace(/[^\w\s]/gi, '').replace(/\s+/g, '').toLowerCase();

      return [id, { image: s.image }];
    })
); */

export const studentsBanners = {
  grade9scienceon: {
    image: "/hashtag-banners/grades/ON/1.png",
  },
  grade9mathematicson: {
    image: "/hashtag-banners/grades/ON/1.png",
  },
  grade9englishon: {
    image: "/hashtag-banners/grades/ON/1.png",
  },
  grade9frenchon: {
    image: "/hashtag-banners/grades/ON/1.png",
  },
  grade9geographyon: {
    image: "/hashtag-banners/grades/ON/1.png",
  },
  grade9healthyactivelivingon: {
    image: "/hashtag-banners/grades/ON/1.png",
  },
  grade9learningstrategieson: {
    image: "/hashtag-banners/grades/ON/1.png",
  },
  grade9technologicaleducationon: {
    image: "/hashtag-banners/grades/ON/1.png",
  },
  grade9artson: {
    image: "/hashtag-banners/grades/ON/1.png",
  },
  grade9firstnationson: {
    image: "/hashtag-banners/grades/ON/1.png",
  },
  grade10scienceon: {
    image: "/hashtag-banners/grades/ON/2.png",
  },
  grade10mathematicson: {
    image: "/hashtag-banners/grades/ON/2.png",
  },
  grade10englishon: {
    image: "/hashtag-banners/grades/ON/2.png",
  },
  grade10canadianhistoryon: {
    image: "/hashtag-banners/grades/ON/2.png",
  },
  grade10careerstudieson: {
    image: "/hashtag-banners/grades/ON/2.png",
  },
  grade10civicson: {
    image: "/hashtag-banners/grades/ON/2.png",
  },
  grade11biologyon: {
    image: "/hashtag-banners/grades/ON/3.png",
  },
  grade11functionson: {
    image: "/hashtag-banners/grades/ON/3.png",
  },
  grade11chemistryon: {
    image: "/hashtag-banners/grades/ON/3.png",
  },
  grade11introductiontoanthropologyon: {
    image: "/hashtag-banners/grades/ON/3.png",
  },
  grade12advancedfunctionson: {
    image: "/hashtag-banners/grades/ON/4.png",
  },
  grade12biologyon: {
    image: "/hashtag-banners/grades/ON/4.png",
  },
  grade12datamanagementon: {
    image: "/hashtag-banners/grades/ON/4.png",
  },
  grade12canadianworldissueson: {
    image: "/hashtag-banners/grades/ON/4.png",
  },
  osslt: {
    image: "/hashtag-banners/grades/CZ/ONCareerZone.jpg",
  },
  oct: {
    image: "/hashtag-banners/grades/CZ/ONCareerZone.jpg",
  },
  "ontario-law": {
    image: "/hashtag-banners/grades/CZ/ONCareerZone.jpg",
  },
  orea: {
    image: "/hashtag-banners/grades/CZ/ONCareerZone.jpg",
  },
  "cpa-ontario": {
    image: "/hashtag-banners/grades/CZ/ONCareerZone.jpg",
  },
  grade9scienceab: {
    image: "/hashtag-banners/grades/AB/AB9.png",
  },
  grade9mathematicsab: {
    image: "/hashtag-banners/grades/AB/AB9.png",
  },
  grade9englishlanguageartsab: {
    image: "/hashtag-banners/grades/AB/AB9.png",
  },
  grade9socialstudiesab: {
    image: "/hashtag-banners/grades/AB/AB9.png",
  },
  grade9physicaleducationab: {
    image: "/hashtag-banners/grades/AB/AB9.png",
  },
  grade9careerandtechnologyfoundationsab: {
    image: "/hashtag-banners/grades/AB/AB9.png",
  },
  grade9healthandlifeskillsab: {
    image: "/hashtag-banners/grades/AB/AB9.png",
  },
  grade9fineartsab: {
    image: "/hashtag-banners/grades/AB/AB9.png",
  },
  grade9indigenousstudiesab: {
    image: "/hashtag-banners/grades/AB/AB9.png",
  },
  grade9frenchasasecondlanguageab: {
    image: "/hashtag-banners/grades/AB/AB9.png",
  },
  grade10scienceab: {
    image: "/hashtag-banners/grades/AB/AB10.png",
  },
  grade10mathematicsab: {
    image: "/hashtag-banners/grades/AB/AB10.png",
  },
  grade10englishlanguageartsab: {
    image: "/hashtag-banners/grades/AB/AB10.png",
  },
  grade10socialstudiesab: {
    image: "/hashtag-banners/grades/AB/AB10.png",
  },
  grade10physicaleducationab: {
    image: "/hashtag-banners/grades/AB/AB10.png",
  },
  grade10careerandlifemanagementab: {
    image: "/hashtag-banners/grades/AB/AB10.png",
  },
  grade10careerandtechnologystudiesctsab: {
    image: "/hashtag-banners/grades/AB/AB10.png",
  },
  grade10artab: {
    image: "/hashtag-banners/grades/AB/AB10.png",
  },
  grade10frenchasasecondlanguageab: {
    image: "/hashtag-banners/grades/AB/AB10.png",
  },
  grade10indigenousstudiesab: {
    image: "/hashtag-banners/grades/AB/AB10.png",
  },
  scienceabgrade11: {
    image: "/hashtag-banners/grades/AB/AB11.png",
  },
  chemistryabgrade11: {
    image: "/hashtag-banners/grades/AB/AB11.png",
  },
  physicsabgrade11: {
    image: "/hashtag-banners/grades/AB/AB11.png",
  },
  mathematicsabgrade11: {
    image: "/hashtag-banners/grades/AB/AB11.png",
  },
  englishlanguageartsabgrade11: {
    image: "/hashtag-banners/grades/AB/AB11.png",
  },
  socialstudiesabgrade11: {
    image: "/hashtag-banners/grades/AB/AB11.png",
  },
  biologyabgrade11: {
    image: "/hashtag-banners/grades/AB/AB11.png",
  },
  careerandlifemanagementabgrade11: {
    image: "/hashtag-banners/grades/AB/AB11.png",
  },
  psychologyabgrade11: {
    image: "/hashtag-banners/grades/AB/AB11.png",
  },
  indigenousstudiesabgrade11: {
    image: "/hashtag-banners/grades/AB/AB11.png",
  },
  careerandtechnologystudiesctsabgrade11: {
    image: "/hashtag-banners/grades/AB/AB11.png",
  },
  artabgrade11: {
    image: "/hashtag-banners/grades/AB/AB11.png",
  },
  frenchasasecondlanguageabgrade11: {
    image: "/hashtag-banners/grades/AB/AB11.png",
  },
  grade12scienceab: {
    image: "/hashtag-banners/grades/AB/AB12.png",
  },
  grade12chemistryab: {
    image: "/hashtag-banners/grades/AB/AB12.png",
  },
  grade12physicsab: {
    image: "/hashtag-banners/grades/AB/AB12.png",
  },
  grade12mathematicsab: {
    image: "/hashtag-banners/grades/AB/AB12.png",
  },
  grade12englishlanguageartsab: {
    image: "/hashtag-banners/grades/AB/AB12.png",
  },
  grade12socialstudiesab: {
    image: "/hashtag-banners/grades/AB/AB12.png",
  },
  grade12biologyab: {
    image: "/hashtag-banners/grades/AB/AB12.png",
  },
  grade12careerandlifemanagementab: {
    image: "/hashtag-banners/grades/AB/AB12.png",
  },
  grade12psychologyab: {
    image: "/hashtag-banners/grades/AB/AB12.png",
  },
  grade12indigenousstudiesab: {
    image: "/hashtag-banners/grades/AB/AB12.png",
  },
  grade12careerandtechnologystudiesctsab: {
    image: "/hashtag-banners/grades/AB/AB12.png",
  },
  grade12artab: {
    image: "/hashtag-banners/grades/AB/AB12.png",
  },
  grade12frenchasasecondlanguageab: {
    image: "/hashtag-banners/grades/AB/AB12.png",
  },
  grade12forensicscienceab: {
    image: "/hashtag-banners/grades/AB/AB12.png",
  },
  // conflicting with alberta province community
  // "alberta": {
  //     "image": "/hashtag-banners/grades/CZ/ABCareerZone.jpg"
  // },
  cpled: {
    image: "/hashtag-banners/grades/CZ/ABCareerZone.jpg",
  },
  reca: {
    image: "/hashtag-banners/grades/CZ/ABCareerZone.jpg",
  },
  ait: {
    image: "/hashtag-banners/grades/CZ/ABCareerZone.jpg",
  },
  grade9sciencebc: {
    image: "/hashtag-banners/grades/BC/BC9.png",
  },
  grade9mathematicsbc: {
    image: "/hashtag-banners/grades/BC/BC9.png",
  },
  grade9englishbc: {
    image: "/hashtag-banners/grades/BC/BC9.png",
  },
  grade9socialstudiesbc: {
    image: "/hashtag-banners/grades/BC/BC9.png",
  },
  grade9physicalandhealtheducationbc: {
    image: "/hashtag-banners/grades/BC/BC9.png",
  },
  grade9applieddesignskillsandtechnologiesbc: {
    image: "/hashtag-banners/grades/BC/BC9.png",
  },
  grade9artseducationbc: {
    image: "/hashtag-banners/grades/BC/BC9.png",
  },
  grade9frenchbc: {
    image: "/hashtag-banners/grades/BC/BC9.png",
  },
  grade9careereducationbc: {
    image: "/hashtag-banners/grades/BC/BC9.png",
  },
  grade10sciencebc: {
    image: "/hashtag-banners/grades/BC/BC10.png",
  },
  grade10mathematicsbc: {
    image: "/hashtag-banners/grades/BC/BC10.png",
  },
  grade10englishbc: {
    image: "/hashtag-banners/grades/BC/BC10.png",
  },
  grade10socialstudiesbc: {
    image: "/hashtag-banners/grades/BC/BC10.png",
  },
  grade11sciencebc: {
    image: "/hashtag-banners/grades/BC/BC11.png",
  },
  grade11mathematicsbc: {
    image: "/hashtag-banners/grades/BC/BC11.png",
  },
  grade11englishbc: {
    image: "/hashtag-banners/grades/BC/BC11.png",
  },
  grade12sciencebc: {
    image: "/hashtag-banners/grades/BC/BC12.png",
  },
  grade12mathematicsbc: {
    image: "/hashtag-banners/grades/BC/BC12.png",
  },
  grade12englishbc: {
    image: "/hashtag-banners/grades/BC/BC12.png",
  },
  "bc-provincial": {
    image: "/hashtag-banners/grades/CZ/BCCareerZone.jpg",
  },
  "bc-bar": {
    image: "/hashtag-banners/grades/CZ/BCCareerZone.jpg",
  },
  "bc-real-estate": {
    image: "/hashtag-banners/grades/CZ/BCCareerZone.jpg",
  },
  scienceettechnologieqc: {
    image: "/hashtag-banners/grades/QC/2.png",
  },
  mathmatiqueqc: {
    image: "/hashtag-banners/grades/QC/3.png",
  },
  histoireduqubecetcanadaqc: {
    image: "/hashtag-banners/grades/QC/2.png",
  },
  chimieqc: {
    image: "/hashtag-banners/grades/QC/3.png",
  },
  des: {
    image: "/hashtag-banners/grades/CZ/QCCareerZone.jpg",
  },
  tcf: {
    image: "/hashtag-banners/grades/CZ/QCCareerZone.jpg",
  },
  g12pt: {
    image: "/hashtag-banners/grades/CZ/Manitoba.jpeg",
  },
  nspe: {
    image: "/hashtag-banners/grades/CZ/NovaScotia.jpeg",
  },
  "g9-pat": {
    image: "/hashtag-banners/grades/CZ/Saskatchewan.jpeg",
  },
  "g9-sspat": {
    image: "/hashtag-banners/grades/CZ/Saskatchewan.jpeg",
  },
};
